<section class="pb-5 anim-loading" *appAdminPermission="'ViewCompany'">
  <div class="container">
    <div class="row">
      <div class="col-md-6">
        <div class="page-title">
          <h2 i18n>Empresas</h2>
        </div>
      </div>
      <div class="col-md-6 d-flex justify-content-end">
        <div class="content">
          <button class="btn btn-primary"
            (click)="openCreateOrUpdateModal()"
            *appAdminPermission="'CreateCompany'">Nova Empresa</button>
        </div>
      </div>
    </div>
    <div class="row mb-5">
      <div class="col-md-12">
        <form [formGroup]="searchForm" (submit)="handleSearch()">
          <div class="input-group">
            <input
              type="text"
              class="form-control form-search"
              placeholder="Buscar registro" formControlName="search"
              autocomplete="off">
            <div class="input-group-append">
              <div class="filter-dropdown">
                <button
                  type="button"
                  class="btn btn-outline-secondary btn-icon filter-dropdown__handle"
                  i18n>
                  <i class="material-icons">filter_alt</i> Filtrar
                </button>
                <div class="filter-dropdown__content">
                  <div class="form-group">
                    <app-input
                      type="native-select"
                      [list]="situationsFilterList"
                      formControlName="situation"
                      selectText="name" selectValue="id" selectShowLimit="2"
                      placeholder="Situação" i18n-placeholder>
                    </app-input>
                  </div>
                  <div class="filter-dropdown__footer">
                    <button i18n class="btn btn-info btn-block"
                      (click)="handleSearch()"
                      data-dismiss="modal">Aplicar</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <table
            class="table table-bordeless table-striped table-hover data-table">
            <thead>
              <tr class="mt-3">
                <th class="text-center" i18n>Habilitado</th>
                <th class="text-center" i18n></th>
                <th class="text-center" i18n>Empresa</th>
                <th class="text-center" i18n>Contratos</th>
                <th class="text-center" i18n>CNPJ</th>
                <th class="text-center" i18n>Ações</th>
              </tr>
            </thead>
            <tbody *ngIf="!loading">
              <tr *ngFor="let company of companies">
                <td class="text-center">
                  <div class="custom-control custom-switch">
                    <label
                      class="custom-control-label"
                      [ngClass]="{ checked: company?.enabled }">
                      <input type="checkbox"
                        class="form-control custom-control-input"
                        *appAdminPermission="'UpdateCompany'"
                        (change)="enabledOrDisabledCompany(company)">
                    </label>
                  </div>
                </td>
                <td class="text-center d-flex" i18n
                  (click)="openViewModal(company)">
                  <span
                    *ngIf="company?.logo !== null && company?.logo?.split('.com/')[1]?.split('?')[0] !== 'undefined'">
                    <img [src]="company?.logo" class="logo">
                  </span>
                  <span
                    *ngIf="!company?.logo || company?.logo?.split('.com/')[1]?.split('?')[0] === 'undefined'">
                    <app-avatar
                      [user]="{ name: company?.name || 'S N' }"
                      class="avatar-userGroup-list">
                    </app-avatar>
                  </span>
                </td>
                <td class="text-center" i18n (click)="openViewModal(company)">
                  {{ company?.name || '-' }}</td>
                <td class="text-center" i18n (click)="openViewModal(company)">
                  <div *ngIf="company?.contractIds?.length > 0">
                    <span
                      *ngFor="let contractId of company?.contractIds.slice(0,6)"
                      class="badge badge-primary mr-1">
                      {{ contractId + '' }}
                    </span>
                    <a *ngIf="company?.contractIds?.length > 6"
                      class="badge badge-primary">...</a>
                  </div>
                  <span
                    *ngIf="!company?.contractIds || company?.contractIds?.length === 0">-</span>
                </td>
                <td class="text-center" i18n (click)="openViewModal(company)">
                  <span *ngIf="company?.cnpj">
                    {{ convertCNPJ(company?.cnpj) }}</span>
                  <span *ngIf="!company?.cnpj">-</span>
                </td>
                <td class="text-center" i18n>
                  <div class="dropdown"
                    *appAdminPermission="['UpdateCompany', 'DeleteCompany']">
                    <button class="btn btn-icon-block" type="button"
                      id="dropdownMenuButton" data-toggle="dropdown"
                      aria-haspopup="true" aria-expanded="false">
                      <i class="material-icons">more_horiz</i>
                    </button>
                    <div class="dropdown-menu dropdown-menu-right"
                      aria-labelledby="dropdownMenuButton">
                      <span>
                        <a class="dropdown-item"
                          (click)="return"
                          *appAdminPermission="['UpdateCompany']"
                          (click)="openCreateOrUpdateModal(true, company)">
                          Editar Empresa</a>
                        <a class="dropdown-item"
                          (click)="deleteCompany(company)"
                          *appAdminPermission="['DeleteCompany']">Remover
                          Empresa</a>
                      </span>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12" *ngIf="!loading">
        <app-pagination
          (items)="setCompanies($event)"
          [params]="params"
          [service]="companyService"
          [permission]="'ViewCompany'"
          [noItemsText]="'Não existe nenhuma empresa cadastrada'">
        </app-pagination>
      </div>
    </div>
    <div class="row" *ngIf="loading">
      <div class="col-md-12">
        <div class="loading-page">
          <div class="loading-spinner">
            <div class="bounce1"></div>
            <div class="bounce2"></div>
            <div class="bounce3"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
